export default {
  ["k_time"]: "Time",
  ["k_open"]: "Open",
  ["k_hight"]: "High",
  ["k_low"]: "Low",
  ["k_close"]: "Receive",
  ["k_quote_amount"]: "Change",
  ["k_quote_change"]: "Change%",
  ["k_volume"]: "Volume",
  ["exchange_1m"]: "1 นาที",
  ["exchange_5m"]: "5 นาที",
  ["exchange_15m"]: "15 นาที",
  ["exchange_30m"]: "30 นาที",
  ["exchange_60m"]: "60 นาที",
  ["exchange_more"]: "มากกว่า",
  ["exchange_4h"]: "4 ชั่วโมง",
  ["exchange_day"]: "วัน",
  ["exchange_month"]: "เดือน",
  ["exchange_week"]: "สัปดาห์",
  ["exchange_year"]: "ปี",
  ["tabbar.home"]: "หน้าแรก",
  ["tabbar.trade"]: "คำคม",
  ["tabbar.hosting"]: "การจัดการทางการเงิน",
  ["tabbar.exchange"]: "ซื้อขาย",
  ["tabbar.account"]: "ทรัพย์สิน",
  ["common.confirm"]: "ยืนยัน",
  ["index.number"]: "สมดุล",
  ["index.Total revenue"]: "รายได้รวม",
  ["index.Trading"]: "เริ่มต้นที่ปรึกษาผู้เชี่ยวชาญ AI",
  ["index.intelligentive trading"]: "เริ่มต้น ai การซื้อขายเชิงปริมาณอย่างชาญฉลาดตอนนี้",
  ["host.detail"]: "รายละเอียด",
  ["host.todayProfit"]: "รายได้วันนี้",
  ["host.totalProfit"]: "กำไรที่คาดว่าจะได้รับ",
  ["host.Order quantity"]: "ปริมาณการสั่งซื้อ",
  ["host.Strategic"]: "ผลิตภัณฑ์กิจกรรมเชิงกลยุทธ์",
  ["host.escrow"]: "จำนวนเงินที่ฝาก",
  ["host.max"]: "มากที่สุด",
  ["host.determine"]: "แน่นอน",
  ["host.balance"]: "ยอดเงินคงเหลือ",
  ["host.Deposit"]: "กองทุนเงินฝาก",
  ["host.quota"]: "ขีดจำกัด",
  ["host.years"]: "อัตรารวมต่อปี",
  ["host.expect"]: "กำไรที่คาดว่าจะได้รับ",
  ["host.lockup"]: "ขุดเหมือง",
  ["host.liquidated"]: "บทลงโทษการแลกของรางวัลก่อนกำหนด",
  ["host.redeem"]: "การไถ่ถอน",
  ["host.isitredeemed"]: "มีบทลงโทษสำหรับการไถ่ถอนก่อนกำหนด มันคือ การไถ่ถอนหรือไม่?",
  ["host.consignmentOrder"]: "คำสั่งที่ได้รับมอบหมาย",
  ["host.purchase"]: "ที่จะซื้อ",
  ["exchange.bond"]: "ระยะขอบฟรี",
  ["exchange.optionNo"]: "ประเด็น",
  ["exchange.endTime"]: "การปิดประเด็นนี้",
  ["exchange.Forecast"]: "ระยะเวลาคาดการณ์",
  ["enter the amount"]: "กรุณากรอกจำนวนเงิน",
  ["Insufficient wallet balance"]: "ยอดเงินในกระเป๋าไม่เพียงพอที่จะซื้อ",
  ["minimum purchase amount is"]: "จำนวนเงินที่ซื้อขั้นต่ำคือ",
  ["Purchase successful"]: "ซื้อสำเร็จ",
  ["exchange.orderConifrm"]: "ยืนยันการสั่งซื้อ",
  ["exchange.balance"]: "ยอดเงินคงเหลือ",
  ["exchange.custormAmount"]: "จำนวนเงินที่กำหนดเอง",
  ["exchange.input"]: "กรุณาป้อน",
  ["exchange.confirm"]: "แน่นอน",
  ["exchange.minute"]: "แลกเปลี่ยนนาที",
  ["exchange.curentrust"]: "อาณัติในปัจจุบัน",
  ["exchange.hisentrust"]: "ค่าคอมมิชชั่นประวัติศาสตร์",
  ["exchange.noneEntrust"]: "ยังไม่มีคำสั่ง",
  ["exchange.wait"]: "รอเปิดนะครับ",
  ["exchange.opened"]: "เปิด",
  ["exchange.rescinded"]: "เพิกถอนแล้ว",
  ["exchange.type"]: "ประเภท",
  ["exchange.finashTime"]: "เวลาทำการ",
  ["exchange.openingQuantity"]: "จำนวนตำแหน่งที่เปิดรับ",
  ["exchange.awards"]: "จำนวนรางวัล",
  ["exchange.charge"]: "ค่าธรรมเนียมในการเปิดตำแหน่ง",
  ["exchange.openPrice"]: "ราคาเปิด",
  ["exchange.close"]: "ราคาปิด",
  ["exchange.prediction"]: "ทิศทางตำแหน่ง",
  ["exchange.pump"]: "ปั๊ม",
  ["hello"]: "สวัสดี",
  ["welcome"]: "ยินดีต้อนรับสู่",
  ["change success"]: "แก้ไขเรียบร้อยแล้ว",
  ["set success"]: "ตั้งเรียบร้อยแล้ว",
  ["confirm"]: "แน่นอน",
  ["confirm1"]: "แน่นอน",
  ["confirm2"]: "แน่นอน",
  ["cancel"]: "ยกเลิก",
  ["copySuccess"]: "คัดลอกสำเร็จ",
  ["please enter"]: "กรุณาป้อน",
  ["no data"]: "ไม่มีข้อมูล",
  ["all"]: "ทั้งหมด",
  ["processing"]: "กำลังประมวลผล",
  ["credited"]: "เงินเข้าแล้ว",
  ["fail"]: "ล้มเหลว",
  ["timeout failed"]: "หมดเวลา",
  ["amount"]: "จำนวนเงิน",
  ["state"]: "สถานะ",
  ["time"]: "เวลา",
  ["pwd_password"]: "รหัสผ่าน",
  ["pwd_Enter password"]: "กรุณาใส่รหัสผ่าน",
  ["pwd_old"]: "รหัสผ่านเก่า",
  ["pwd_new"]: "รหัสผ่านใหม่",
  ["pwd_new again"]: "ยืนยันรหัสผ่าน",
  ["pwd_Enter old password"]: "กรุณาใส่รหัสผ่านเก่า",
  ["pwd_Enter new password"]: "กรุณาใส่รหัสผ่านใหม่",
  ["pwd_Enter new password again"]: "กรุณาใส่รหัสผ่านใหม่อีกครั้ง",
  ["pwd_set"]: "ตั้งรหัสผ่าน",
  ["pwd_not empty"]: "รหัสผ่านไม่สามารถเว้นว่างได้",
  ["pwd_length"]: "ความยาวรหัสผ่านต้องไม่ต่ำกว่า 6 ตัวอักษร",
  ["pwd_old not empty"]: "รหัสผ่านเก่าไม่สามารถเว้นว่างได้",
  ["pwd_new not empty"]: "รหัสผ่านใหม่ไม่สามารถเว้นว่างได้",
  ["pwd_inconsistent twice"]: "รหัสผ่านทั้งสองไม่ตรงกัน",
  ["home_msg"]: "เทคโนโลยีเป็นจิตวิญญาณร่วมกันของผู้ที่พัฒนามัน",
  ["home_recharge"]: "ฝากด่วน",
  ["home_exchange"]: "ตัวเลือกการซื้อขาย",
  ["home_mining"]: "ขุดเหมือง",
  ["home_service"]: "บริการออนไลน์",
  ["home_increaseList"]: "รายชื่อผู้ได้รับ",
  ["home_turnover"]: "ปริมาณ",
  ["home_currencyName"]: "ชื่อ",
  ["home_newPrice"]: "ราคาล่าสุด",
  ["home_vol24"]: "ปริมาณการซื้อขายตลอด 24 ชั่วโมง",
  ["home_upDown"]: "การเปลี่ยนแปลงใบเสนอราคา",
  ["home_warrant"]: "สกุลเงินหลัก",
  ["trade_tab1"]: "ตัวเลือกเสริม",
  ["trade_tab2"]: "Coin-M Futures",
  ["trade_tab3"]: "Exchange",
  ["trade_tab4"]: "การทำรายการตามสัญญา",
  ["trade_tab5"]: "USDⓈ-M",
  ["trade_tab6"]: "สัญญาที่สอง",
  ["trade.empty"]: "ไม่มีข้อมูล",
  ["edit_choice"]: "ทางเลือกของบรรณาธิการ",
  ["add_optional"]: "เพิ่มในตัวเลือก",
  ["save"]: "บันทึก",
  ["select_all"]: "เลือกทั้งหมด",
  ["delete"]: "ลบ",
  ["please_choose"]: "โปรดเลือก",
  ["sidebar_share"]: "ฉันต้องการแบ่งปัน",
  ["sidebar_help"]: "ศูนย์ช่วยเหลือ",
  ["sidebar_service"]: "บริการออนไลน์",
  ["exchange_selCurrency"]: "เลือกสกุลเงิน",
  ["exchange_searchText"]: "โปรดป้อนคำค้นหา",
  ["exchange_rule"]: "กฎ",
  ["exchange_bond"]: "ระยะขอบฟรี",
  ["exchange_optionNo"]: "ประเด็น",
  ["exchange_endTime"]: "การปิดประเด็นนี้",
  ["exchange_forecast"]: "ระยะเวลาคาดการณ์",
  ["exchange_minute"]: "นาที",
  ["exchange_curentrust"]: "อาณัติปัจจุบัน",
  ["exchange_noneEntrust"]: "ยังไม่มีคำสั่ง",
  ["exchange_bullish"]: "การแลกเปลี่ยนเป็นขาขึ้น",
  ["exchange_bearish"]: "การแลกเปลี่ยนเป็นขาลง",
  ["exchange_orderConifrm"]: "ยืนยันการสั่งซื้อ",
  ["exchange_balance"]: "ยอดเงินคงเหลือ",
  ["exchange_custormAmount"]: "จำนวนเงินที่กำหนดเอง",
  ["host_lockup"]: "ขุดเหมือง",
  ["host_consignmentOrder"]: "คำสั่งที่ได้รับมอบหมาย",
  ["host_purchase"]: "ที่จะซื้อ",
  ["mining_purchase"]: "ที่จะซื้อ",
  ["host_todayProfit"]: "รายได้วันนี้",
  ["host_totalProfit"]: "กำไรที่คาดว่าจะได้รับ",
  ["host_limit"]: "ขีดจำกัดการลงทุน",
  ["host_income"]: "รายได้",
  ["host_funds in custody"]: "กองทุนในความดูแล",
  ["host_entrusted order"]: "คำสั่งที่ได้รับมอบหมาย",
  ["host_expected earnings for today"]: "กำไรที่คาดหวังสำหรับวันนี้",
  ["host_cumulative income"]: "รายได้สะสม",
  ["host_order in commission"]: "สั่งเป็นคอมมิชชั่น",
  ["host_day"]: "วัน",
  ["host_single limit"]: "ขีด จำกัด เดียว",
  ["host_daily rate of return"]: "อัตราผลตอบแทนรายวัน",
  ["host_cycle"]: "ระยะเวลา",
  ["host_processing"]: "การประมวลผล",
  ["host_completed"]: "สมบูรณ์",
  ["host.redeemed"]: "แลกแล้ว",
  ["host_histotyProfit"]: "รายได้ในอดีต",
  ["host_illustrate"]: "แสดงให้เห็น",
  ["host_order details"]: "รายละเอียดการสั่งซื้อ",
  ["host_single benefit"]: "ผลประโยชน์เดียว",
  ["host_single day income"]: "รายได้วันเดียว",
  ["host_total revenue"]: "รายได้รวม",
  ["host_earnings Details"]: "รายละเอียดรายได้",
  ["host_paid"]: "ชำระเงินแล้ว",
  ["host_pay miner fees"]: "จ่ายค่าธรรมเนียมการขุด",
  ["host_user output"]: "ผลลัพธ์ของผู้ใช้",
  ["host_address"]: "ที่อยู่",
  ["host_quantity"]: "ปริมาณ",
  ["host_time"]: "เวลา",
  ["host_account Balance"]: "ยอดเงินในบัญชี",
  ["account_total assets equivalent"]: "รวมมูลค่าทรัพย์สิน",
  ["account_deposit"]: "เงินฝาก",
  ["account_withdraw"]: "ถอนเงิน",
  ["account_exchange"]: "แลกเปลี่ยน",
  ["account_funding Account"]: "บัญชีเงินทุน",
  ["account_hide small coins"]: "ซ่อนเหรียญขนาดเล็ก",
  ["account_available"]: "ใช้ได้",
  ["account_processing"]: "กำลังประมวลผล",
  ["account_folded"]: "พับแล้ว",
  ["recharge"]: "เติมเงิน",
  ["recharge_currency"]: "เติมเงินสกุลเงิน",
  ["recharge_scan code transfer"]: "สแกนรหัสโอนและเติมเงิน",
  ["recharge_amount"]: "จำนวนเติมเงิน",
  ["recharge_upload"]: "อัปโหลดภาพหน้าจอของรายละเอียดการชำระเงิน",
  ["recharge_record"]: "บันทึกการเติมเงิน",
  ["recharge_enter amount"]: "กรุณากรอกจำนวนเงินที่เติม",
  ["recharge_less zero"]: "จำนวนเติมเงินต้องไม่น้อยกว่า 0",
  ["recharge_upload screenshot"]: "โปรดอัปโหลดภาพหน้าจอ",
  ["recharge_try again later"]: "กำลังอัปโหลดรูปภาพ โปรดลองอีกครั้งในภายหลัง",
  ["recharge_successful"]: "เติมเงินสำเร็จ",
  ["recharge_Details"]: "รายละเอียดการเติมเงิน",
  ["recharge_currency2"]: "สกุลเงิน",
  ["recharge_address"]: "ที่อยู่เติมเงิน",
  ["recharge_order number"]: "เลขที่ใบสั่งซื้อ",
  ["loading"]: "กำลังโหลด...",
  ["investment amount"]: "จำนวนเงินลงทุน",
  ["expire date"]: "วันที่หมดอายุ",
  ["order number"]: "เลขที่ใบสั่งซื้อ",
  ["start date"]: "วันที่เริ่มต้น",
  ["end date"]: "วันที่สิ้นสุด",
  ["cash back"]: "เงินคืน",
  ["order"]: "订单",
  ["swap"]: "แลกเปลี่ยน",
  ["swap_currency exchange"]: "แลกเปลี่ยนเงินตรา",
  ["swap_please enter exchange amount"]: "กรุณาใส่จำนวนเงินที่แลกเปลี่ยน",
  ["swap_exchange quantity"]: "ปริมาณการแลกเปลี่ยน",
  ["swap_up to"]: "ไม่เกิน",
  ["swap_redeem all"]: "แลกทั้งหมด",
  ["swap_exchange rate"]: "อัตราแลกเปลี่ยน",
  ["swap_available"]: "มีจำหน่าย",
  ["withdraw"]: "ถอนออก",
  ["withdrawal_currency"]: "สกุลเงินถอน",
  ["withdrawal_Amount_Available"]: "จำนวนเงินที่มีจำหน่าย",
  ["withdrawal_Please_enter_amount"]: "กรุณากรอกจำนวนเงินที่ถอน",
  ["withdrawal_remove_all"]: "เอาออกทั้งหมด",
  ["withdrawal_address"]: "ที่อยู่การถอน",
  ["withdrawal_Please_enter_address"]: "กรุณากรอกที่อยู่กระเป๋าเงิน",
  ["withdrawal_password"]: "รหัสผ่านการถอน",
  ["withdrawal_Please_enter_password"]: "กรุณาใส่รหัสผ่านการถอนเงิน",
  ["withdrawal_handling_fee"]: "ค่าดำเนินการ",
  ["withdrawal_Reminder_text"]: "คำเตือน: ส่วนหนึ่งของค่าธรรมเนียมการจัดการจะถูกเรียกเก็บสำหรับการถอนเงินและจะได้รับภายใน 24 ชั่วโมงหลังจากการถอนเงิน หากคุณมีคำถามใด ๆ โปรดติดต่อฝ่ายบริการลูกค้า",
  ["withdrawal_under_review"]: "อยู่ระหว่างการพิจารณา",
  ["withdrawal_success"]: "ถอนสำเร็จ",
  ["withdrawal_examination_passed"]: "สอบผ่านแล้ว",
  ["withdrawal_paying_on_behalf"]: "ชำระเงินในนาม",
  ["withdrawal_payment_overtime"]: "ค่าล่วงเวลา",
  ["withdrawal_record"]: "บันทึกการถอน",
  ["enter the bet amount"]: "กรุณาใส่จำนวนเงินเดิมพัน",
  ["minimum bet amount"]: "จำนวนเงินเดิมพันขั้นต่ำคือ",
  ["bet up to"]: "จำนวนเงินเดิมพันสูงสุดคือ",
  ["number is being updated"]: "กำลังอัปเดตปัญหา โปรดลองอีกครั้งในภายหลัง",
  ["checkout success"]: "สั่งสำเร็จ",
  ["exchange amount cannot be blank"]: "จำนวนเงินที่แลกต้องไม่ว่างเปล่า",
  ["exchange amount must be greater than 0"]: "จำนวนการแลกเปลี่ยนต้องมากกว่า 0",
  ["successfully redeemed"]: "คุณได้ส่งการแลกเปลี่ยนเรียบร้อยแล้ว กรุณารอสักครู่",
  ["enter the withdrawal amount"]: "กรุณากรอกจำนวนเงินที่ถอน",
  ["amount cannot be less than 0"]: "จำนวนถอนต้องไม่น้อยกว่า 0",
  ["enter the withdrawal address"]: "กรุณากรอกที่อยู่ถอนเงิน",
  ["enter the withdrawal password"]: "กรุณาใส่รหัสผ่านการถอนเงิน",
  ["successful application"]: "สมัครสำเร็จ",
  ["set the password first"]: "กรุณาตั้งรหัสผ่านก่อน",
  ["Withdrawal details"]: "รายละเอียดการถอน",
  ["Withdrawal quantity"]: "ปริมาณการถอน",
  ["Withdrawal address"]: "ที่อยู่ถอนเงิน",
  ["share_invite"]: "ชวนเพื่อนมาใช้งาน",
  ["share_link"]: "แบ่งปันลิงค์",
  ["share"]: "แบ่งปัน",
  ["add_success"]: "เพิ่มเรียบร้อยแล้ว",
  ["mining.question1"]: "การทำเหมือง Stake คืออะไร? รายได้มาจากไหน?",
  ["mining.answer1"]: "การทำ Stake Mining เป็นผลิตภัณฑ์เครื่องมือที่สร้างขึ้นโดยบริษัทเพื่อช่วยให้ผู้ใช้รับคำมั่นในห่วงโซ่อย่างรวดเร็วเพื่อรับรางวัล โดยการปักหลักสินทรัพย์ดิจิทัลบนเครือข่ายบล็อคเชน และรับรางวัลตามกลไก POS (หลักฐานการถือหุ้น นั่นคือ หลักฐานการถือหุ้น) ในกลไกนี้ ผู้ใช้มอบทรัพย์สินดิจิทัลให้กับโหนด และโหนดใช้สิทธิ์ในการผลิตบล็อก ธุรกรรมแพ็กเกจ ฯลฯ บนบล็อกเชนและรับรางวัล ผู้ใช้แบ่งปันรางวัลที่ได้รับจากโหนดตามสัดส่วนตามจำนวนตำแหน่งที่ถูกล็อค",
  ["mining.question2"]: "การอ้างอิงรายปีคืออะไร? วิธีการคำนวณ?",
  ["mining.answer2"]: "อัตราอ้างอิงแบบรายปีคืออัตราอ้างอิงรายปีของการส่งคืนผลิตภัณฑ์ที่คุณสมัครรับข้อมูล ซึ่งจะได้รับการอัปเดตแบบไดนามิกตามรายได้จริงในเครือข่าย สำหรับการอ้างอิงของคุณเท่านั้น การอ้างอิงรายปี = รายได้บนเชน/ปริมาณการล็อคบนเชน/เวลาล็อคบนเชน*365*100%",
  ["mining.question3"]: "ผลตอบแทนที่คาดว่าจะได้รับคืออะไร? วิธีการคำนวณ?",
  ["mining.answer3"]: "รายได้ที่คาดหวังคือรายได้ที่คาดหวังรายวันซึ่งคำนวณจากปริมาณการสมัครรับข้อมูลและการอ้างอิงผลิตภัณฑ์แบบรายปี และใช้สำหรับการอ้างอิงเท่านั้น ผลตอบแทนที่คาดหวังรายวัน = จำนวนการสมัคร * อ้างอิงรายปี / 365",
  ["mining.question4"]: "ดอกเบี้ยเริ่มสะสมเมื่อไหร่?",
  ["mining.answer4"]: "สำหรับการสมัครสมาชิกในวันที่ T ดอกเบี้ยจะคำนวณจาก 00:00 น. ในวันที่ T+1",
  ["mining.question5"]: "เมื่อไหร่จะกระจายผลประโยชน์?",
  ["mining.answer5"]: "การสมัครสมาชิกในวันที่ T ดอกเบี้ยจะเริ่มสร้างในวันที่ T+1 และรายได้จะถูกกระจายไปพร้อมกับเงินต้นหลังจากครบกำหนด",
  ["mining.question6"]: "ฉันสามารถแลกใช้ผลิตภัณฑ์ตามระยะเวลาก่อนกำหนดได้หรือไม่ ผลกระทบคืออะไร?",
  ["mining.answer6"]: "คุณสามารถแลกรับสินค้าได้ทุกเมื่อ แต่หากคุณแลกรับสินค้าตามเงื่อนไขล่วงหน้า คุณจะสูญเสียรายได้ส่วนหนึ่งที่ได้รับจากคำสั่งซื้อนั้น และรายได้ที่ออกนั้นจะถูกหักออกจากเงินต้นของคุณในขณะที่แลกรับ",
  ["mining.question7"]: "ฉันจำเป็นต้องแลกใช้ด้วยตนเองหลังจากระยะเวลาที่ผลิตภัณฑ์หมดอายุหรือไม่",
  ["mining.answer7"]: "ไถ่ถอนอัตโนมัติเมื่อสินค้าหมดระยะเวลา",
  ["mining.question8"]: "1ฉันจะเข้าร่วมได้อย่างไร",
  ["mining.answer8"]: "ในการเข้าร่วมการขุดสภาพคล่องแบบไม่ทำลาย คุณต้องจ่าย ETH เป็นค่าธรรมเนียมนักขุด ที่อยู่กระเป๋าเงินคริปโตเคอเรนซี (cryptocurrency) จำเป็นต้องอ้างสิทธิ์เพียงครั้งเดียวและการอนุญาตการขุดจะเปิดโดยอัตโนมัติหลังจากประสบความสำเร็จ",
  ["mining.question9"]: "2. ฉันจะถอนเงินได้อย่างไร?",
  ["mining.answer9"]: "คุณสามารถแปลงเหรียญที่สร้างรายวันเป็น USDT แล้วเริ่มการถอนได้ การถอน USDT จะถูกส่งไปยังที่อยู่กระเป๋าเงินที่คุณเพิ่มไปยังโหนดโดยอัตโนมัติ ไม่รองรับที่อยู่อื่น",
  ["mining.question10"]: "3. คำนวณรายได้อย่างไร?",
  ["mining.answer10"]: "เมื่อคุณเข้าร่วมสำเร็จ สัญญาอัจฉริยะจะเริ่มคำนวณที่อยู่ของคุณผ่านโหนด และเริ่มคำนวณรายได้",
  ["show_more"]: "ดูเพิ่มเติม",
  ["promble"]: "ปัญหาที่พบบ่อย",
  ["what_yeb"]: "Yu'e Bao คืออะไร?",
  ["what_yeb_answer"]: "Yubibao เป็นผลิตภัณฑ์ที่สร้างขึ้นโดยบริษัทเพื่อช่วยเหลือผู้ใช้ที่มีสินทรัพย์ดิจิทัลที่ไม่ได้ใช้งานและผู้ใช้ที่ต้องการยืมเงิน มีลักษณะเฉพาะของการฝากและถอนเงินทันที การคำนวณดอกเบี้ยรายชั่วโมง และรองรับการปรับแต่งอัตราดอกเบี้ย หลังจากที่ผู้ใช้โอนสินทรัพย์ดิจิทัลไปยัง Yubibao ระบบจะกำหนดว่าเงินกู้จะสำเร็จในแต่ละชั่วโมงหรือไม่ตามอัตราการให้ยืมที่กำหนดโดยผู้ใช้ หลังจากการกู้ยืมสำเร็จ จะได้รับดอกเบี้ยเป็นชั่วโมง มิฉะนั้น ไม่สามารถรับดอกเบี้ยได้และคุณต้องรอในครั้งต่อไป หนึ่งชั่วโมง ผลการจับคู่ อาศัยระบบควบคุมความเสี่ยงที่เข้มงวด Yubibao รับประกันความปลอดภัยของการทำธุรกรรมของผู้ใช้อย่างเต็มที่",
  ["what_lixi"]: "ดอกเบี้ยคำนวณอย่างไร?",
  ["what_lixi_answer"]: "ดอกเบี้ย (ต่อวัน) = จำนวนเงินกู้ * สินเชื่อตลาดรายปี / 365/24 * 85%",
  ["rule_yeb_cont1"]: "Yubibao เป็นผลิตภัณฑ์ที่สร้างขึ้นโดยบริษัทเพื่อช่วยเหลือผู้ใช้ที่มีสินทรัพย์ดิจิทัลที่ไม่ได้ใช้งานและผู้ใช้ที่ต้องการยืมเงิน มีลักษณะเฉพาะของการฝากและถอนเงินทันที การคำนวณดอกเบี้ยรายชั่วโมง และรองรับการปรับแต่งอัตราดอกเบี้ย หลังจากที่ผู้ใช้โอนสินทรัพย์ดิจิทัลไปยัง Yubibao ระบบจะกำหนดว่าเงินกู้จะสำเร็จในแต่ละชั่วโมงหรือไม่ตามอัตราการให้ยืมที่กำหนดโดยผู้ใช้ หลังจากการกู้ยืมสำเร็จ จะได้รับดอกเบี้ยเป็นชั่วโมง มิฉะนั้น ไม่สามารถรับดอกเบี้ยได้และคุณต้องรอในครั้งต่อไป หนึ่งชั่วโมง ผลการจับคู่ อาศัยระบบควบคุมความเสี่ยงที่เข้มงวด Yubibao รับประกันความปลอดภัยของการทำธุรกรรมของผู้ใช้อย่างเต็มที่",
  ["rule_yeb_note1"]: "*โปรดทราบ: การคืนสินค้าในอดีตไม่ได้บ่งบอกถึงผลตอบแทนในอนาคต เราไม่สัญญาว่าจะชำระคืนเงินต้นและดอกเบี้ยเป็นสกุลเงิน วัตถุทางกายภาพ ทุน หรือรูปแบบอื่นใดของการคืนทรัพย์สินภายในระยะเวลาหนึ่ง",
  ["rule_yeb_title2"]: "ข้อดีของผลิตภัณฑ์",
  ["rule_yeb_til2"]: "แข็งแกร่ง",
  ["rule_yeb_cont2"]: "อาศัยระบบควบคุมความเสี่ยงที่เข้มงวด Yu'ebao รับประกันความปลอดภัยของทรัพย์สินของผู้ใช้อย่างเต็มที่และเพลิดเพลินกับผลประโยชน์ด้วยความอุ่นใจ",
  ["rule_yeb_title3"]: "คำแนะนำการลงทุนในสินทรัพย์ที่มีรายได้ดอกเบี้ย",
  ["rule_yeb_cont3"]: "หลังจากที่ผู้ใช้โอนสินทรัพย์ของตนไปยัง Yubibao แล้ว สินทรัพย์ดิจิทัลที่ซื้อจะถูกให้ยืมแก่ผู้ใช้ที่ซื้อขายด้วยเลเวอเรจ",
  ["rule_yeb_title4"]: "งบกำไรขาดทุน",
  ["rule_yeb_til4"]: "กฎรายได้",
  ["rule_yeb_cont4"]: "หากการประมูลสำเร็จ รายได้จากวันก่อนหน้าจะถูกทบและชำระในเวลา 02:00 น. ของวันถัดไป",
  ["rule_yeb_title5"]: "คำอธิบายขององค์ประกอบรายได้",
  ["rule_yeb_cont5"]: "15% ของดอกเบี้ยเงินกู้ของผู้ใช้จะถูกใช้เป็นส่วนต่างความเสี่ยง และ 85% จะถูกจัดสรรให้กับผู้ใช้ที่ให้ยืม นั่นคือ ดอกเบี้ยที่ผู้ใช้ให้ยืมจะได้รับคือ: เงินต้นเงินกู้ * สินเชื่อรายปีปัจจุบัน / 365 / 24 * 85 %",
  ["rule_yeb_title6"]: "คำอธิบายรายการ",
  ["rule_yeb_cont61"]: "รองรับการสมัครสมาชิกได้ทุกเมื่อ เริ่มประมูลในชั่วโมงหลังสมัครสมาชิก",
  ["rule_yeb_cont62"]: 'กฎการจับคู่อัตราดอกเบี้ย: ตลาดเสนอราคาทุก ๆ ชั่วโมงตามความต้องการในการกู้ยืมตาม "รายปีเงินกู้ขั้นต่ำ" จากต่ำไปสูง และมูลค่าสูงสุดของการประมูลจะใช้เป็น "รายปีเงินกู้ปัจจุบัน"',
  ["rule_yeb_cont63"]: "ถ้าเงินกู้รายปีขั้นต่ำ < รายปีเงินกู้ปัจจุบัน เงินกู้รายปีปัจจุบันจะถูกใช้เพื่อให้ยืมสำเร็จ",
  ["rule_yeb_cont64"]: "ถ้าเงินกู้รายปีขั้นต่ำ > เงินกู้รายปีปัจจุบัน เงินกู้ล้มเหลวและไม่มีดอกเบี้ย",
  ["rule_yeb_cont65"]: "ถ้าเงินกู้รายปีขั้นต่ำ = เงินกู้รายปีปัจจุบัน เงินกู้อาจยืมบางส่วนหรือเงินกู้อาจล้มเหลว",
  ["rule_yeb_title7"]: "กฎการแลกของรางวัล",
  ["rule_yeb_til7"]: "ไถ่ถอนอัตโนมัติเมื่อครบกำหนด",
  ["rule_wk_title1"]: "การทำเหมือง Stake คืออะไร? รายได้มาจากไหน?",
  ["rule_wk_cont1"]: "การทำ Stake Mining เป็นผลิตภัณฑ์เครื่องมือที่สร้างขึ้นโดยบริษัทเพื่อช่วยให้ผู้ใช้รับคำมั่นในห่วงโซ่อย่างรวดเร็วเพื่อรับรางวัล โดยการปักหลักสินทรัพย์ดิจิทัลบนเครือข่ายบล็อคเชน และรับรางวัลตามกลไก POS (หลักฐานการถือหุ้น นั่นคือ หลักฐานการถือหุ้น) ในกลไกนี้ ผู้ใช้มอบทรัพย์สินดิจิทัลให้กับโหนด และโหนดใช้สิทธิ์ในการผลิตบล็อก ธุรกรรมแพ็กเกจ ฯลฯ บนบล็อกเชนและรับรางวัล ผู้ใช้แบ่งปันรางวัลที่ได้รับจากโหนดตามสัดส่วนตามจำนวนตำแหน่งที่ถูกล็อค",
  ["rule_wk_note1"]: "*โปรดทราบ: การคืนสินค้าในอดีตไม่ได้บ่งบอกถึงผลตอบแทนในอนาคต เราไม่สัญญาว่าจะชำระคืนเงินต้นและดอกเบี้ยเป็นสกุลเงิน วัตถุทางกายภาพ ทุน หรือรูปแบบอื่นใดของการคืนทรัพย์สินภายในระยะเวลาหนึ่ง",
  ["rule_wk_title2"]: "ข้อดีของผลิตภัณฑ์",
  ["rule_wk_til2"]: "แข็งแกร่ง",
  ["rule_wk_cont2"]: "การขุด Stake จะได้รับผลตอบแทนที่ค่อนข้างคงที่จากบุคคลที่สาม โดยมีช่วงระยะเวลาของผลิตภัณฑ์ที่หลากหลาย",
  ["rule_wk_title3"]: "คำแนะนำการลงทุนในสินทรัพย์ที่มีรายได้ดอกเบี้ย",
  ["rule_wk_cont3"]: "การขุด Stake คือการจำนำทรัพย์สินดิจิทัลของคุณบน blockchain เพื่อสนับสนุนการทำงานของเครือข่าย blockchain และรับรางวัลที่เกี่ยวข้อง",
  ["rule_wk_title4"]: "งบกำไรขาดทุน",
  ["rule_wk_cont4"]: "หลังจากสมัครสมาชิกสำเร็จในวันที่ T ดอกเบี้ยเริ่มต้นเวลา 00:00 น. ของวัน T+1 และชำระดอกเบี้ยเวลา 02:00 น.",
  ["rule_wk_title5"]: "รายละเอียดธุรกรรม",
  ["rule_wk_til5"]: "กฎการซื้อ",
  ["rule_wk_cont5"]: "สนับสนุนการสมัครสมาชิกได้ตลอดเวลา",
  ["rule_wk_title6"]: "กฎการแลกของรางวัล",
  ["rule_wk_cont61"]: "รองรับการแลกรับเมื่อใดก็ได้ และเวลารอการแลกของโครงการต่าง ๆ นั้นแตกต่างกัน",
  ["rule_wk_cont62"]: "เมื่อระยะเวลายังไม่หมดอายุจะมีการไถ่ถอนล่วงหน้าและหักดอกเบี้ยบางส่วนที่จ่ายไป",
  ["rule_wk_cont63"]: "ไม่รองรับการแลกรับ",
  ["rule_wk_title7"]: "คำเตือนความเสี่ยง",
  ["rule_wk_cont7"]: "สำหรับการแลกรับสินค้าปกติก่อนกำหนด ระบบจะหักรายได้ส่วนหนึ่งที่ได้รับจากการสั่งซื้อ",
  ["rule_fzywk_title1"]: "การขุดสภาพคล่อง",
  ["rule_fzywk_cont1"]: "การขุดสภาพคล่องเป็นฟังก์ชันการบริหารความมั่งคั่งที่สร้างขึ้นโดยบริษัทเพื่อช่วยเหลือผู้ใช้ในการจัดการสินทรัพย์ดิจิทัลและสร้างผลตอบแทนในระยะยาวและมีประสิทธิภาพ ผู้ใช้คลิก (จ่ายค่าธรรมเนียมผู้ขุด) และจ่ายค่าธรรมเนียมการขุดเพื่อสร้างรายได้ทันที ผู้ใช้ต้องจ่ายเพียงครั้งเดียวเพื่อให้มีผลถาวร และไม่จำเป็นต้องคลิกเพื่อจ่ายอีกในอนาคต อัตราส่วนรายได้ขึ้นอยู่กับ บนยอดดุลกระเป๋าเงินของผู้ใช้ ยิ่งยอดสูง อัตราส่วนรายได้ก็ยิ่งมากขึ้น",
  ["rule_fzywk_note"]: "หมายเหตุ: (ไม่มีการให้ยืม) รายละเอียดรายได้จะถูกส่ง 4 ครั้งต่อวันทุกๆ 6 ชั่วโมง คุณสามารถดูรายละเอียดรายได้ผ่านรายละเอียดรายได้",
  ["rule_fzywk_note1"]: "หมายเหตุ: (ผลิตภัณฑ์นี้เป็นผลิตภัณฑ์ระบายน้ำเพื่อสวัสดิการที่มีโควตาจำกัดในปัจจุบัน ในอนาคต การประเมินสินทรัพย์ดิจิทัลจะเพิ่มให้กับผู้ใช้ และผลิตภัณฑ์นี้จะเปิดสำหรับผู้ใช้ที่ผ่านการรับรองเท่านั้น จึงได้มาก่อนได้ก่อน)",
  ["rule_fzywk_title2"]: "ข้อดีของผลิตภัณฑ์",
  ["rule_fzywk_til2"]: "ผลประโยชน์ที่แข็งแกร่ง",
  ["rule_fzywk_cont2"]: "สามารถรับผลประโยชน์ระยะยาวโดยไม่ต้องให้กู้ยืมเงิน รับรองความปลอดภัยของทรัพย์สินของผู้ใช้ และเพลิดเพลินกับผลประโยชน์โดยไม่เสี่ยงต่อการสูญเสีย",
  ["rule_fzywk_title3"]: "งบกำไรขาดทุน",
  ["rule_fzywk_til3"]: "กฎเกณฑ์รายได้",
  ["rule_fzywk_cont3"]: "จะมีผลทันทีหลังจากอนุมัติการชำระเงินสำเร็จและรายได้จะกระจายภายในระยะเวลาที่กำหนดของทุกวัน รอบรายได้ของผู้ใช้คือ 6 ชั่วโมง และสามารถรับรายได้ทั้งหมด 4 เท่าภายใน 24 ชั่วโมง",
  ["rule_fzywk_til3_1"]: "อัตราส่วนรายได้เกียร์",
  ["rule_fzywk_tab1"]: "เกียร์",
  ["rule_fzywk_tab2"]: "ปริมาณ",
  ["rule_fzywk_tab3"]: "อัตราผลตอบแทนรายวัน",
  ["rule_fzywk_tab4"]: "หน่วยรายได้",
  ["unlimited"]: "ไม่ จำกัด",
  ["verified"]: "ตรวจสอบแล้ว",
  ["verified_tips"]: "เพื่อให้แน่ใจว่าประสบการณ์บัญชีที่ปลอดภัย โปรดผูกข้อมูลส่วนบุคคลของคุณ",
  ["verified_name"]: "ชื่อ",
  ["verified_input_name"]: "กรุณาพิมพ์ชื่อของคุณ",
  ["verified_card"]: "ใบอนุญาตเลขที่",
  ["verified_input_card"]: "กรุณากรอกหมายเลขประจำตัวประชาชน",
  ["photo_front"]: "รูปถ่ายติดบัตร",
  ["clearly_visible"]: "(กรุณาตรวจสอบเอกสารให้ชัดเจน)",
  ["front_photo"]: "อัพโหลดรูปหน้าบัตรประชาชน",
  ["reverse_photo"]: "อัปโหลดด้านหลังของรูปถ่าย ID ของคุณ",
  ["standard"]: "มาตรฐาน",
  ["missing"]: "หายไป",
  ["vague"]: "ไม่ชัดเจน",
  ["strong flash"]: "แฟลชที่แข็งแกร่ง",
  ["confirm_submit"]: "ยืนยันและส่ง",
  ["need to change"]: "หากคุณต้องการเปลี่ยนการผูกกรุณา",
  ["Contact Customer Service"]: "ติดต่อฝ่ายบริการลูกค้า",
  ["authentication succeeded"]: "รับรองความถูกต้องสำเร็จ",
  ["please_information"]: "กรุณากรอกข้อมูลให้ครบถ้วน",
  ["only_symbol"]: "เพียงแค่ดูคู่การซื้อขายปัจจุบัน",
  ["options"]: "ตัวเลือก",
  ["occupy"]: "ครอบครอง",
  ["bb_buy"]: "ซื้อ",
  ["bb_sell"]: "ขาย",
  ["bb_count"]: "ปริมาณ",
  ["bb_current_best_price"]: "ซื้อขายในราคาที่ดีที่สุดในปัจจุบัน",
  ["bb_turnover"]: "มูลค่าการซื้อขาย",
  ["bb_Limit order"]: "จำกัดการสั่งซื้อ",
  ["bb_market order"]: "คำสั่งของตลาด",
  ["bb_successful operation"]: "การดำเนินงานที่ประสบความสำเร็จ",
  ["bb_operation failed"]: "การดำเนินการล้มเหลว",
  ["bb_Hide other trading pairs"]: "ซ่อนคู่การซื้อขายอื่น ๆ",
  ["bb_price"]: "ราคา",
  ["bb_volume"]: "ปริมาณ",
  ["bb_default"]: "ค่าเริ่มต้น",
  ["bb_buy order"]: "สั่งซื้อสินค้า",
  ["bb_sell order"]: "คำสั่งขาย",
  ["bb_commission price"]: "ราคาคอมมิชชั่น",
  ["bb_commission amount"]: "จำนวนเงินค่าคอมมิชชั่น",
  ["bb_Cancellation"]: "การยกเลิก",
  ["bb_total turnover"]: "มูลค่าการซื้อขายทั้งหมด",
  ["bb_Average transaction price"]: "มูลค่าซื้อขายเฉลี่ย",
  ["bb_Undo succeeded"]: "เลิกทำสำเร็จแล้ว",
  ["bb_Undo failed"]: "เลิกทำไม่สำเร็จ",
  ["bb_Deal done"]: "จัดการเรียบร้อยแล้ว",
  ["bb_Revoked"]: "เพิกถอนแล้ว",
  ["bb_depth map"]: "แผนที่ความลึก",
  ["bb_actual price"]: "ราคาจริง",
  ["bb_to buy order"]: "สั่งซื้อสินค้า",
  ["bb_to sell order"]: "คำสั่งขาย",
  ["bb_direction"]: "ทิศทางตำแหน่ง",
  ["bb_clinch"]: "ทำข้อตกลง",
  ["user_login"]: "เข้าสู่ระบบผู้ใช้",
  ["password_placeholder"]: "กรุณาใส่รหัสผ่าน",
  ["code_placeholder"]: "กรุณาใส่รหัสยืนยัน",
  ["login"]: "เข้าสู่ระบบผู้ใช้",
  ["no account"]: "ไม่มีบัญชี?",
  ["to register"]: "ลงทะเบียน",
  ["Forgot password"]: "ลืมรหัสผ่าน?",
  ["user register"]: "การลงทะเบียนผู้ใช้",
  ["username"]: "ชื่อผู้ใช้",
  ["repassword_placeholder"]: "กรุณาใส่รหัสผ่านอีกครั้ง",
  ["register"]: "ลงทะเบียน",
  ["have account"]: "มีบัญชีอยู่แล้ว?",
  ["to login"]: "เข้าระบบ",
  ["address_placeholder"]: "กรุณากรอกที่อยู่กระเป๋าเงิน",
  ["password does not match"]: "รหัสผ่านทั้งสองไม่ตรงกัน",
  ["username_msg"]: "กรุณากรอกชื่อผู้ใช้",
  ["ua_msg"]: "กรุณากรอกชื่อผู้ใช้/ที่อยู่กระเป๋าเงิน",
  ["register_failed"]: "การลงทะเบียนไม่สำเร็จ",
  ["login_failed"]: "เข้าสู่ระบบล้มเหลว",
  ["invalid_address"]: "ที่อยู่ไม่ถูกต้อง กรุณาเปิดและอนุญาตในกระเป๋าเงิน",
  ["exchange_hisentrust"]: "ค่าคอมมิชชั่นประวัติศาสตร์",
  ["sidebar_bindPassword"]: "ตั้งรหัสผ่านกองทุน",
  ["sidebar_changePassword"]: "แก้ไขรหัสผ่านกองทุน",
  ["sidebar_setLoginPassword"]: "การตั้งรหัสผ่านเข้าสู่ระบบ",
  ["sidebar_changeLoginPassword"]: "แก้ไขรหัสผ่านเข้าสู่ระบบ",
  ["add_address"]: "ผูกที่อยู่",
  ["paste"]: "วาง",
  ["No amount available"]: "ไม่มีจำนวนเงิน",
  ["Please commission amount"]: "กรุณากรอกจำนวนเงินค่าคอมมิชชั่น",
  ["country"]: "ประเทศที่คุณถือสัญชาติอยู่",
  ["verified_input_country"]: "กรุณากรอกสัญชาติ",
  ["Please select a chain"]: "กรุณาเลือกห่วงโซ่",
  ["login_out"]: "ออกจากระบบ",
  ["login_out_sure"]: "คุณแน่ใจว่าจะออกจากระบบ?",
  ["login_out_success"]: "ออกได้สำเร็จ",
  ["login_out_faild"]: "ออกไม่สำเร็จ",
  ["login_out_cancel"]: "ยกเลิกทางออก",
  ["real_name_withdrawal"]: "โปรดดำเนินการยืนยันชื่อจริงให้เสร็จสิ้นโดยเร็วที่สุดก่อนที่จะถอนออก",
  ["going_long"]: "ยาวไป",
  ["open_empty"]: "เปิด",
  ["can_open_empty"]: "เปิดได้",
  ["cash_deposit"]: "มาร์จิ้น",
  ["fund_transfer"]: "การโอนเงิน",
  ["from"]: "จาก",
  ["arrive"]: "มาถึง",
  ["fund_account"]: "บัญชีเงินทุน",
  ["transaction_account"]: "บัญชีซื้อขายหลักทรัพย์",
  ["transfer_all"]: "โอนทั้งหมด",
  ["up_to"]: "จนถึง",
  ["contract_account"]: "บัญชีสัญญา",
  ["spot_account"]: "บัญชีสปอต",
  ["transfer_amount"]: "กรุณาระบุจำนวนเงินที่โอน",
  ["max_transfer"]: "โอนได้ถึง",
  ["current_position"]: "ตำแหน่งปัจจุบัน",
  ["minimum_transfer"]: "จำนวนเงินโอนขั้นต่ำคือ",
  ["sell"]: "ขาย",
  ["buy"]: "ซื้อ",
  ["null"]: "โมฆะ",
  ["income"]: "รายได้",
  ["yield_rate"]: "อัตราผลตอบแทน",
  ["open_interest"]: "เปิดดอกเบี้ย",
  ["position_collateral_assets"]: "หลักทรัพย์ค้ำประกันตำแหน่ง",
  ["average_opening_price"]: "ราคาเปิดเฉลี่ย",
  ["expected_strong_parity"]: "คาดหวังความเท่าเทียมกันที่แข็งแกร่ง",
  ["guaranteed_asset_ratio"]: "อัตราส่วนทรัพย์สินที่รับประกัน",
  ["close_position"]: "ปิดตำแหน่ง",
  ["adjustment_margin"]: "มาร์จิ้นการปรับ",
  ["stop_profit"]: "ทำกำไร",
  ["stop_loss"]: "หยุดการสูญเสีย",
  ["profit_loss"]: "ทำกำไรและหยุดการสูญเสีย",
  ["many"]: "มากมาย",
  ["cancel_bulk"]: "ยกเลิกจำนวนมาก",
  ["trigger_price"]: "ราคาทริกเกอร์",
  ["mark"]: "เครื่องหมาย",
  ["order_price"]: "ราคาสั่งซื้อ",
  ["total_entrustment"]: "จำนวนเงินที่มอบหมายทั้งหมด",
  ["latest_price"]: "ราคาซื้อขายล่าสุด",
  ["profit_price"]: "ราคาทริกเกอร์ทำกำไร",
  ["loss_price"]: "ราคาทริกเกอร์หยุดการสูญเสีย",
  ["profit_order"]: "คำสั่งทำกำไร",
  ["loss_order"]: "คำสั่งหยุดการสูญเสีย",
  ["profit_tips_1"]: "ราคาตลาดถึง",
  ["profit_tips_2"]: "คำสั่ง take profit จะถูกเรียกใช้เมื่อการทำธุรกรรมเสร็จสิ้น และผลกำไรที่คาดว่าจะเกิดขึ้นหลังจากการทำธุรกรรม",
  ["profit_tips_3"]: "เมื่อมีการทริกเกอร์คำสั่งหยุดการขาดทุน การขาดทุนที่คาดหวังหลังจากธุรกรรม",
  ["order_count"]: "ปริมาณ",
  ["market_price"]: "ราคาตลาด",
  ["limit_price"]: "ราคาจำกัด",
  ["margin_call"]: "มาร์จิ้นคอล",
  ["margin_reduction"]: "การลดมาร์จิ้น",
  ["sustainable"]: "ที่ยั่งยืน",
  ["increase_most"]: "เพิ่มขึ้นมากที่สุด",
  ["reduce_most"]: "ลดสูงสุด",
  ["after_price"]: "ราคาการชำระบัญชีหลังการบวก",
  ["add_lever"]: "เลเวอเรจที่เพิ่มขึ้น",
  ["sub_price"]: "ลดราคาการชำระบัญชี",
  ["sub_lever"]: "เลเวอเรจที่ลดลง",
  ["commission_detail"]: "รายละเอียดค่าคอมมิชชั่น",
  ["to_trade"]: "กับการค้า",
  ["order_status"]: "สถานะการสั่งซื้อ",
  ["delegate_type"]: "ประเภทผู้รับมอบสิทธิ์",
  ["volume"]: "ปริมาณ",
  ["delegate_value"]: "ค่าตัวแทน",
  ["commission_time"]: "เวลาคอมมิชชั่น",
  ["currency_least_purchase"]: "ต้องซื้อขั้นต่ำ",
  ["quick_close"]: "ปิดด่วน",
  ["closing_price"]: "ราคาปิด",
  ["completely_sold"]: "ขายหมดแล้วจ้า",
  ["not_contract_transactions"]: "สกุลเงินปัจจุบันไม่รองรับการทำธุรกรรมตามสัญญา",
  ["coinbase_h_l_hot"]: "สกุลเงินยอดนิยม",
  ["coinbase_h_market"]: "ราคาสกุลเงิน",
  ["coinbase_h_coin"]: "สกุลเงิน",
  ["coinbase_h_vol"]: "ปริมาณการซื้อขาย",
  ["coinbase_h_price"]: "ราคา",
  ["coinbase_h_quote"]: "เปลี่ยนใบเสนอราคา",
  ["coinbase_h_more"]: "ดูเพิ่มเติม",
  ["coinbase_h_pt"]: "แพลตฟอร์มการซื้อขายสกุลเงินดิจิทัลที่ผู้ใช้ไว้วางใจ",
  ["coinbase_h_tit1"]: "กองทุนสินทรัพย์ความปลอดภัยผู้ใช้ (SAFU)",
  ["coinbase_h_conn1"]: "จัดเก็บ 10% ของค่าธรรมเนียมการทำธุรกรรมทั้งหมดในกองทุนสินทรัพย์ปลอดภัยเพื่อให้การคุ้มครองเงินทุนของผู้ใช้บางส่วน",
  ["coinbase_h_tit2"]: "การควบคุมการเข้าถึงส่วนบุคคล",
  ["coinbase_h_conn2"]: "การควบคุมการเข้าถึงขั้นสูงจะจำกัดการเข้าถึงอุปกรณ์และที่อยู่ของบัญชีส่วนบุคคล ทำให้ผู้ใช้สบายใจ",
  ["coinbase_h_tit3"]: "การเข้ารหัสข้อมูลขั้นสูง",
  ["coinbase_h_conn3"]: "ข้อมูลการทำธุรกรรมส่วนบุคคลได้รับการรักษาความปลอดภัยผ่านการเข้ารหัสแบบ end-to-end และมีเพียงบุคคลเท่านั้นที่สามารถเข้าถึงข้อมูลส่วนบุคคลได้",
  ["coinbase_hq_title"]: "คำถามที่เกี่ยวข้อง",
  ["coinbase_hq_tit1"]: "1. Defi คืออะไร?",
  ["coinbase_hq_conn1"]: "ชื่อเต็มของ DeFi คือ Decentralized Finance หรือที่เรียกว่าเปิดการเงิน, เกือบทั้งหมดDeFiโครงการทั้งหมดดำเนินการบน Ethereum blockchain Ethereum เป็นแพลตฟอร์มโอเพ่นซอร์สระดับโลกสำหรับแอปพลิเคชันที่กระจายอำนาจ บน Ethereum คุณสามารถเขียนโค้ดเพื่อจัดการสินทรัพย์ดิจิทัลและรันโปรแกรมได้โดยไม่มีข้อจำกัดทางภูมิศาสตร์",
  ["coinbase_hq_tit2"]: "2. ข้อดีของการกระจายอำนาจทางการเงินคืออะไร?",
  ["coinbase_hq_conn2"]: "การเงินแบบกระจายอำนาจใช้ประโยชน์จากหลักการสำคัญของบล็อคเชนเพื่อปรับปรุงความมั่นคงทางการเงินและความโปร่งใส ปลดล็อกสภาพคล่องและโอกาสในการเติบโต และสนับสนุนระบบเศรษฐกิจแบบบูรณาการและได้มาตรฐาน สัญญาอัจฉริยะที่ตั้งโปรแกรมได้สูงทำงานอัตโนมัติและสนับสนุนการสร้างเครื่องมือทางการเงินและสินทรัพย์ดิจิทัลใหม่ การรวบรวมข้อมูลที่ป้องกันการงัดแงะในสถาปัตยกรรมแบบกระจายอำนาจของบล็อคเชนช่วยเพิ่มความปลอดภัยและความสามารถในการตรวจสอบ",
  ["coinbase_hq_tit3"]: "3. Defi ทำธุรกรรมอย่างไร?",
  ["coinbase_hq_conn3"]: 'ปัจจุบัน Defi รองรับสัญญาถาวร สัญญาการส่งมอบ และการซื้อขายเชิงปริมาณอะลูมิเนียม สัญญาถาวรเป็นประเภทของฟิวเจอร์ส "นวัตกรรม" สัญญา สัญญาดั้งเดิมมีวันหมดอายุ แต่สัญญาถาวรไม่มีวันส่งมอบและสามารถถือได้ตลอดไป ดังนั้นจึงเรียกว่าสัญญาถาวร การซื้อขายเชิงปริมาณด้วยตนเองหมายถึงการใช้เทคโนโลยีคอมพิวเตอร์ที่มีอยู่เพื่อวิเคราะห์ข้อมูลจำนวนมากในระยะเวลาอันสั้น จากนั้นทำการซื้อขายโดยอัตโนมัติผ่านรูปแบบการซื้อขายที่เขียนไว้ล่วงหน้าเพื่อปรับปรุงประสิทธิภาพการซื้อขาย คอมพิวเตอร์เครื่องนี้ใช้เพื่อซื้อขายสเปรดในการแลกเปลี่ยนที่สำคัญ',
  ["coinbase_hq_tit4"]: "4. ทำไมต้องเลือก coinbase สำหรับการซื้อขาย?",
  ["coinbase_hq_conn4"]: 'การดำเนินงานในสภาพแวดล้อมที่มีการควบคุมอย่างเข้มงวด Coinbase มีขั้นตอนเพิ่มเติมเพื่อให้แน่ใจว่าข้อมูลลูกค้าได้รับการคุ้มครอง และแม้แต่นักวิทยาศาสตร์และวิศวกรด้านข้อมูลของ Coinbase เองก็ไม่สามารถเข้าถึงข้อมูลนี้ได้ฟรี โค้ดใดๆ ที่ทำงานบนเซิร์ฟเวอร์ที่ใช้งานจริงของ Coinbase จะต้องผ่านการตรวจสอบโค้ดจากหลายกลุ่มก่อนที่จะเริ่มใช้งานจริง "หลักการสำคัญประการหนึ่งของเราคือความปลอดภัยเป็นอันดับแรก เนื่องจากสินทรัพย์ดิจิทัลที่จัดเก็บบนแพลตฟอร์มของเราเป็นของลูกค้า',
  ["coinbase_hq_tit5"]: "5. วิสัยทัศน์ของ Pangea Capital Management ในการเป็นพันธมิตรกับ Coinbase",
  ["coinbase_hq_conn5"]: "2019 Pan Continental Capital Management. การจัดหาเงินทุนจำนวน 230 ล้านดอลลาร์เพื่อเข้าสู่ตลาดสกุลเงินของ Coinbase เป็นผู้นำในการสร้างความร่วมมือเชิงกลยุทธ์กับ Coinbase การแลกเปลี่ยนสกุลเงิน Coinbase ที่ใหญ่ที่สุดในสหรัฐอเมริกา ในแง่ของบล็อกเชน และร่วมมือกับ Coinabse เพื่อทำการวิจัยเชิงลึกเกี่ยวกับการเงินแบบกระจายอำนาจของ Defi และสร้างเทคโนโลยีบล็อกเชนอิสระและแอปพลิเคชั่นกระจายอำนาจ ดำเนินการแลกเปลี่ยนสกุลเงิน coinbase แบบกระจายอำนาจ หน่วยงานตรวจสอบสัญญา",
  ["coinbase_ho_tit1"]: "ผู้ตรวจสอบสัญญา",
  ["coinbase_ho_tit2"]: "สปอต/เลเวอเรจ/สัญญา",
  ["coinbase_ho_tit3"]: "การขุด Stake, DeFi เป็นต้น",
  ["coinbase_ho_tit4"]: "กำลังจะเริ่มซื้อขาย",
  ["coinbase_ho_tit5"]: "แพลตฟอร์มการแลกเปลี่ยนแบบกระจายอำนาจ",
  ["coinbase_ho_tit6"]: "ซื้อขายตอนนี้",
  ["coinbase_ho_tit7"]: "พันธมิตร",
  ["coinbase_ho_tit8"]: "เชื่อมต่อกระเป๋าสตางค์",
  ["coinbase_ho_tit9"]: "เบราว์เซอร์ของคุณไม่รองรับส่วนขยายกระเป๋าเงิน",
  ["coinbase_hs_tit1"]: "เงื่อนไขการให้บริการ",
  ["coinbase_hs_tit2"]: "กระดาษสีขาว",
  ["coinbase_hs_tit3"]: "การตรวจสอบอีเมล",
  ["coinbase_he_tit1"]: "การผูกอีเมล",
  ["coinbase_he_tit2"]: "จดหมาย",
  ["coinbase_he_tit3"]: "รหัสยืนยัน",
  ["coinbase_he_tit4"]: "ส่งรหัสยืนยัน",
  ["coinbase_he_tit5"]: "กรุณากรอกอีเมล์ของคุณ",
  ["coinbase_he_tit6"]: "ส่งซ้ำ",
  ["tokpiedex_he_tit3"]: "รหัสยืนยัน",
  ["opening time"]: "เวลาเปิดทำการ",
  ["view_desc"]: "ดูคำอธิบาย",
  ["host_non-collateralized mining"]: "การขุด Defi",
  ["air_activity"]: "กิจกรรมแอร์ดรอป",
  ["total_output"]: "ผลผลิตทั้งหมด",
  ["valid_node"]: "โหนดที่ถูกต้อง",
  ["participant"]: "ผู้เข้าร่วม",
  ["user_benefit"]: "ประโยชน์ของผู้ใช้",
  ["participate_mining"]: "เข้าร่วมการขุด",
  ["take_over"]: "รับช่วงต่อ",
  ["divide"]: "การแบ่ง",
  ["balance_reaches"]: "เมื่อยอดเงินในกระเป๋าเงินถึง",
  ["you_get"]: "คุณจะได้รับ",
  ["mining_pool"]: "รางวัลจากการขุดสระ",
  ["valid_time"]: "รับเวลาที่ถูกต้อง:",
  ["air_activity_help_1"]: "สัญญาอัจฉริยะคือโปรโตคอลคอมพิวเตอร์ที่ออกแบบมาเพื่อเผยแพร่ ตรวจสอบ หรือทำสัญญาในลักษณะที่ให้ข้อมูล สัญญาที่ชาญฉลาดช่วยให้สามารถติดตามธุรกรรมที่เชื่อถือได้และไม่สามารถย้อนกลับได้โดยไม่มีบุคคลที่สาม แนวคิดของสัญญาอัจฉริยะได้รับการเสนอครั้งแรกโดย Nick Szabo ในปี 1995 วัตถุประสงค์ของสัญญาอัจฉริยะคือการจัดหาวิธีการที่ปลอดภัยซึ่งเหนือกว่าสัญญาแบบเดิม ลดต้นทุนการทำธุรกรรมอื่นๆ ที่เกี่ยวข้องกับสัญญา สัญญาอัจฉริยะดำเนินการอย่างอิสระโดยสมบูรณ์ โดยปราศจากการแทรกแซงของมนุษย์ และยุติธรรมและยุติธรรม",
  ["air_activity_help_2"]: "Airdrops ทำงานโดยอัตโนมัติด้วยสัญญาอัจฉริยะของ Ethereum และไม่ใช่ผู้ใช้ทุกคนที่มีสิทธิ์เข้าร่วมใน airdrops เมื่อคุณได้รับงานแอร์ดรอปสำหรับสัญญาอัจฉริยะ คุณจะต้องทำเงื่อนไขงานให้สำเร็จเพื่อรับรางวัลเท่านั้น",
  ["air_activity_help_3"]: "มาตรฐานของภารกิจแอร์ดรอปต่างกัน และรางวัลที่ได้รับก็ต่างกัน",
  ["submit_success"]: "ส่งเรียบร้อยแล้ว",
  ["verified_wait"]: "กำลังตรวจสอบข้อมูล",
  ["air_activity_msg_1"]: "ขอบคุณสำหรับการเข้าร่วม รางวัล ETH ได้ถูกแจกจ่ายไปยังยอดเงินในบัญชีของคุณแล้ว",
  ["promotion_center"]: "ศูนย์ส่งเสริม",
  ["invite_friende"]: "ชวนเพื่อนมารับเหรียญด้วยกัน",
  ["invite_friends_commission"]: "เชิญเพื่อน เติมเงินทันทีและรับค่าคอมมิชชั่น",
  ["promotion_rule"]: "ดูกฎการส่งเสริมการขาย",
  ["my_promotion"]: "โปรโมชั่นของฉัน",
  ["total_promotions"]: "จำนวนโปรโมชั่นทั้งหมด",
  ["commission_amount"]: "ค่าคอมมิชชั่น",
  ["generation_p"]: "รุ่น",
  ["second_generation_p"]: "จำนวนรุ่นที่สอง",
  ["three_generations_p"]: "สามชั่วอายุคน",
  ["invitation_code_y"]: "รหัสเชิญของคุณ",
  ["sponsored_link"]: "ลิงก์ผู้สนับสนุน",
  ["click_share"]: "คลิกเพื่อแบ่งปัน",
  ["commission_details"]: "รายละเอียดค่าคอมมิชชั่น",
  ["generation"]: "รุ่น",
  ["second_generation"]: "รุ่นที่สอง",
  ["three_generations"]: "สามชั่วอายุคน",
  ["user_ID"]: "รหัสผู้ใช้",
  ["rebate_amount"]: "จำนวนเงินคืน",
  ["registration_time"]: "เวลาลงทะเบียน",
  ["QRcode_register"]: "สแกน QR code เพื่อลงทะเบียน",
  ["click_save"]: "คลิกบันทึก",
  ["share_amount"]: "จำนวน",
  ["invitation_code"]: "รหัสคำเชิญ (ไม่บังคับ)",
  ["option_buy_up"]: "comprar",
  ["option_buy_short"]: "comprar corto",
  ["option_countdown"]: "cuenta regresiva",
  ["option_purchase_price"]: "precio de compra",
  ["option_profitability"]: "Rentabilidad",
  ["option_minimum_amount"]: "monto minimo",
  ["option_profit_loss"]: "Ganancias y pérdidas estimadas",
  ["option_latest_price"]: "Último precio",
  ["option_now_price"]: "precio actual",
  ["option_profit_loss_1"]: "Ganancia y perdida",
  ["option_profit_loss_2"]: "จำนวนการซื้อขั้นต่ำ",
  ["option_profit_loss_3"]: "ราคาสุดท้ายขึ้นอยู่กับการชำระบัญชีของระบบ",
  ["host_single_limit_1"]: "โควต้า",
  ["record_tip"]: "หมายเหตุ",
  ["record_tip_1"]: "เรียนคุณลูกค้า สินค้าที่คุณซื้อหมดแล้ว โปรดติดต่อฝ่ายบริการลูกค้า",
  ["available_time"]: "เวลาที่ว่าง",
  ["about_us"]: "เกี่ยวกับเรา",
  ["home_tip_agree"]: "โดยการลงทะเบียนฉันเห็นด้วย",
  ["home_tip_terms"]: "ข้อกำหนดการใช้งาน",
  ["home_tip_agreement"]: "นโยบายความเป็นส่วนตัว",
  ["home_tip_score"]: "คะแนนเครดิต",
  ["home_tip_service_email"]: "อีเมลฝ่ายบริการลูกค้าอย่างเป็นทางการ",
  ["home_tip_and"]: "และ",
  ["quick_label_1"]: "การชำระบัญชีเสร็จสิ้น",
  ["quick_label_2"]: "ราคาปัจจุบัน",
  ["quick_label_3"]: "รอบ",
  ["quick_label_5"]: "ปริมาณ",
  ["quick_label_6"]: "ราคา",
  ["quick_label_7"]: "กำไรที่คาดหวัง",
  ["coinbase2_buy_tip"]: "โปรดติดต่อฝ่ายบริการลูกค้าเพื่อซื้อ",
  ["upload_file_error"]: "ขนาดไฟล์เกิน 1.5M และไม่สามารถอัพโหลดได้ กรุณาเปลี่ยนภาพที่จะอัพโหลด",
  ["tokpiedex_home_recharge"]: "ฝากด่วน",
  ["tokpiedex_trade_tab6"]: "สัญญาที่สอง",
  ["defi_host_non-collateralized mining"]: "การขุด Defi",
  ["defi_host_lockup"]: "ขุดเหมือง",
  ["defi_participate_mining"]: "เข้าร่วมการขุด",
  ["defi_host_non-collateralized"]: "การขุด Defi",
  ["defi_h_pt"]: "แพลตฟอร์มการซื้อขายสกุลเงินดิจิทัลที่ผู้ใช้ไว้วางใจ",
  ["defi_hq_tit4"]: "4. ทำไมต้องเลือก Coinsaving สำหรับการซื้อขาย?",
  ["defi_hq_tit5"]: "5. วิสัยทัศน์ของ Pangea Capital Management ในการเป็นพันธมิตรกับ Coinsaving",
  ["defi_hq_conn4"]: 'การดำเนินงานในสภาพแวดล้อมที่มีการควบคุมอย่างเข้มงวด Coinsaving มีขั้นตอนเพิ่มเติมเพื่อให้แน่ใจว่าข้อมูลลูกค้าได้รับการคุ้มครอง และแม้แต่นักวิทยาศาสตร์และวิศวกรด้านข้อมูลของ Coinsaving เองก็ไม่สามารถเข้าถึงข้อมูลนี้ได้ฟรี โค้ดใดๆ ที่ทำงานบนเซิร์ฟเวอร์ที่ใช้งานจริงของ Coinsaving จะต้องผ่านการตรวจสอบโค้ดจากหลายกลุ่มก่อนที่จะเริ่มใช้งานจริง "หลักการสำคัญประการหนึ่งของเราคือความปลอดภัยเป็นอันดับแรก เนื่องจากสินทรัพย์ดิจิทัลที่จัดเก็บบนแพลตฟอร์มของเราเป็นของลูกค้า',
  ["defi_hq_conn5"]: "2019 Pan Continental Capital Management. การจัดหาเงินทุนจำนวน 230 ล้านดอลลาร์เพื่อเข้าสู่ตลาดสกุลเงินของ Coinsaving เป็นผู้นำในการสร้างความร่วมมือเชิงกลยุทธ์กับ Coinsaving การแลกเปลี่ยนสกุลเงิน Coinsaving ที่ใหญ่ที่สุดในสหรัฐอเมริกา ในแง่ของบล็อกเชน และร่วมมือกับ Coinabse เพื่อทำการวิจัยเชิงลึกเกี่ยวกับการเงินแบบกระจายอำนาจของ Defi และสร้างเทคโนโลยีบล็อกเชนอิสระและแอปพลิเคชั่นกระจายอำนาจ ดำเนินการแลกเปลี่ยนสกุลเงิน Coinsaving แบบกระจายอำนาจ หน่วยงานตรวจสอบสัญญา",
  ["rachange_link_huobi"]: "ช่องทางเติมเงินอย่างเป็นทางการของ Huobi",
  ["rachange_link_binance"]: "ช่องทางการฝาก Binance อย่างเป็นทางการ",
  ["rachange_link_coinbase"]: "ช่องทางการเติมเงินอย่างเป็นทางการของ Coinbase",
  ["rachange_link_crypto"]: "ช่องทางการเติมเงินอย่างเป็นทางการของ Crypto",
  ["recharge_hash"]: "รหัสธุรกรรม",
  ["recharge_hash_placeholder"]: "กรุณากรอกรหัสธุรกรรม",
  ["symbol_closed"]: "ปิด",
  ["email_placeholder"]: "กรุณากรอกอีเมล์ของคุณ",
  ["email_title"]: "จดหมาย",
  ["email_code"]: "รหัสยืนยัน",
  ["email register"]: "การลงทะเบียนอีเมล",
  ["email login"]: "เข้าสู่ระบบอีเมล",
  ["email_code_placeholder"]: "กรุณากรอกรหัสยืนยันอีเมล์",
  ["use_email_change"]: "ใช้อีเมลเพื่อแก้ไข",
  ["use_password_change"]: "ใช้รหัสผ่านเดิมเพื่อแก้ไข",
  ["tip_change"]: "หมายเหตุ: หากกล่องจดหมายไม่ถูกผูกไว้ หรือกล่องจดหมายสูญหาย กรุณา",
  ["forgot_password"]: "ลืมรหัสผ่าน",
  ["i_know"]: "ฉันเห็น",
  ["regulatory_permission"]: "ใบอนุญาตทางการเงิน",
  ["regulatory_conn_1"]: "PLATFORM_TITLE Group อยู่ภายใต้การกำกับดูแลที่เข้มงวดโดยสถาบันการเงินที่มีอำนาจในหลายแห่งในโลก รวมถึง Australian Securities and Investments Commission (หมายเลขข้อบังคับ: 001296201) และ Canadian Financial Market Conduct Authority (หมายเลขข้อบังคับ: M19578081) PLATFORM_TITLE ปฏิบัติตามข้อบังคับทางการเงินที่เข้มงวดของ Australian Securities and Investments Commission และ Canadian Financial Market Conduct Authority ภายใต้การกำกับดูแลของหน่วยงานกำกับดูแล PLATFORM_TITLE รับประกันความโปร่งใสของการทำธุรกรรมทั้งหมด และเป็นหนึ่งในผู้ค้าตราสารอนุพันธ์ทางการเงินที่น่าเชื่อถือที่สุดในโลก",
  ["regulatory_conn_2"]: "Versign เป็นพันธมิตรด้านความปลอดภัยเครือข่ายระดับโลกของ PLATFORM_TITLE Capital Group เกตเวย์ใช้เทคโนโลยีการเข้ารหัสขั้นสูงมาตรฐานสูงสุดของอุตสาหกรรมถึง 256 บิตเพื่อให้มั่นใจถึงความปลอดภัยออนไลน์ของลูกค้าและการทำธุรกรรมออนไลน์ขนาดใหญ่ตามปกติเพื่อให้ลูกค้าปลอดภัยและเชื่อถือได้ จัดการธุรกรรมบนเว็บไซต์ทางการของ PLATFORM_TITLE ฝากและถอน และแก้ไขข้อมูลลูกค้าและขั้นตอนอื่นๆ Verisign เป็นผู้ให้บริการขั้นพื้นฐานที่ยอดเยี่ยม โดยให้บริการที่สามารถรับประกันความคืบหน้าอย่างราบรื่นของธุรกรรมออนไลน์หลายร้อยล้านรายการทุกวัน Verisign เป็นผู้ให้บริการไดเร็กทอรีที่เชื่อถือได้สำหรับชื่อโดเมน .com, net, .cc และ .tv ทั้งหมด โดยมีเครือข่าย SS7 อิสระที่ใหญ่ที่สุดในโลก ทุกวัน Verisign ตรวจสอบบันทึกความปลอดภัยมากกว่า 1.5 พันล้านรายการทั่วโลก และรักษาความปลอดภัยเว็บเซิร์ฟเวอร์มากกว่า 500,000 เครื่อง",
  ["regulatory_conn_3"]: "วิธีการวิเคราะห์ที่ได้รับรางวัลและได้รับรางวัลของ Trading Central ใช้ตัวบ่งชี้ทางเทคนิคที่ได้รับการพิสูจน์แล้ว ไม่ว่าจะเป็นการซื้อขายระหว่างวัน การซื้อขายแบบแกว่ง หรือการลงทุนระยะยาว Trading Central สามารถให้บริการนักลงทุนด้วยแผนภูมิและการวิเคราะห์ทางคณิตศาสตร์ที่ตรงตามข้อกำหนดของรูปแบบการลงทุนต่างๆ",
  ["regulatory_conn_4"]: "ในกว่า 30 ประเทศทั่วโลก สถาบันการเงินชั้นนำระดับโลกกว่า 100 แห่งเลือกใช้การวิจัยการลงทุนและการวิเคราะห์ทางเทคนิคที่จัดทำโดย Trading Central",
  ["regulatory_conn_5"]: "TRADING CENTRAL ยังเป็นสมาชิกที่ได้รับการรับรองจากสมาคมผู้ให้บริการการวิจัยอิสระ (IRP) สามแห่ง ได้แก่ Investorside, European IRP และ Asia IRP TRADING CENTRAL ให้บริการวิจัยทางการเงินอิสระที่สอดคล้องกับความสนใจของนักลงทุนและปราศจากความขัดแย้งทางผลประโยชน์ด้านวาณิชธนกิจ",
  ["username_placeholder"]: "ชื่อผู้ใช้/ที่อยู่กระเป๋าเงิน/อีเมล",
  ["air_title"]: "รางวัลกิจกรรม Mining Pool",
  ["air_content"]: "รางวัลกิจกรรมพูลการขุดหมายเลข: 951 ERC-20 สัญญาจำนำอัจฉริยะ คุณจะได้รับทันทีหากคุณเข้าร่วม",
  ["pulling_text"]: "ดึงลงเพื่อรีเฟรช...",
  ["loosing_text"]: "ปล่อยเพื่อรีเฟรช...",
  ["pledge_amount"]: "จำนวนเงินทางการเงินที่ชาญฉลาด",
  ["deposit_amount"]: "จำนวนเงินฝากที่จำเป็น",
  ["tokpiedex_home_increaseList"]: "รายชื่อผู้ได้รับ",
  ["tokpiedex_home_turnover"]: "ปริมาณ",
  ["tokpiedex_trade_tab1"]: "ตัวเลือกเสริม",
  ["tokpiedex_home_service"]: "บริการออนไลน์",
  ["cwg_host_non-collateralized mining"]: "การขุด Defi",
  ["help_loan"]: "ช่วยกู้",
  ["loan_tip"]: "หลังจากการตรวจสอบแพลตฟอร์ม คุณสามารถขอสินเชื่อจากแพลตฟอร์มได้!",
  ["loan_amount"]: "จำนวนเงินกู้ที่คาดหวัง",
  ["repayment_cycle"]: "รอบการชำระคืน",
  ["daily_rate"]: "อัตรารายวัน",
  ["repayment"]: "การชำระคืน",
  ["interest"]: "ความสนใจ",
  ["repayment_principal_maturity"]: "ครบกำหนดชำระหนึ่งงวด",
  ["lending_institution"]: "สถาบันสินเชื่อ",
  ["credit_loan"]: "สินเชื่อเงินกู้ (กรุณาใส่รูปให้ชัดเจน)",
  ["upload_passport_photo"]: "อัปโหลดภาพถ่ายหนังสือเดินทาง",
  ["approval"]: "การอนุมัติ",
  ["approval_failed"]: "การอนุมัติล้มเหลว",
  ["reps"]: "การชำระคืน",
  ["overdue"]: "ค้างชำระ",
  ["loan_money"]: "จำนวนเงินกู้",
  ["repayment_date"]: "วันที่ชำระคืน",
  ["mechanism"]: "สถาบันสินเชื่อ",
  ["loan_record"]: "บันทึกการกู้ยืม",
  ["primary_certification"]: "การรับรองหลัก",
  ["advanced_certification"]: "การรับรองขั้นสูง",
  ["certificate_type"]: "ประเภทของใบรับรอง",
  ["example"]: "ตัวอย่าง",
  ["passport"]: "หนังสือเดินทาง",
  ["id_card"]: "บัตรประจำตัวประชาชน",
  ["driver_license"]: "ใบอนุญาตขับรถ",
  ["show_passport_photo"]: "รูปถ่ายหนังสือเดินทาง",
  ["show_front_photo"]: "รูปถ่ายหนังสือเดินทาง",
  ["show_reverse_photo"]: "รูปถ่ายหนังสือเดินทาง",
  ["minimum_borrowing"]: "เงินกู้ขั้นต่ำ",
  ["copy_link"]: "สำเนา",
  ["to_be_confirmed"]: "ได้รับการยืนยัน",
  ["notify"]: "แจ้ง",
  ["account_frozen"]: "บัญชีถูกระงับ โปรดติดต่อฝ่ายบริการลูกค้า",
  ["mining_pool_rewards"]: "รางวัลพูลการขุด",
  ["output"]: "เอาต์พุต",
  ["required"]: "ต้องเติมเงิน",
  ["reward"]: "รางวัล",
  ["popup_miniing_title"]: "สมัครรับรางวัลพูลการขุด",
  ["popup_miniing_conn1"]: "ERC-20 สัญญาอัจฉริยะ",
  ["popup_miniing_conn2"]: "กลุ่มการขุดสัญญาอัจฉริยะ ERC-20 กำลังจะเริ่มกิจกรรมแบ่งปัน ETH ครั้งต่อไป สมัครตอนนี้เพื่อเข้าร่วม หลังจากกิจกรรมเริ่มขึ้น ผู้ให้บริการสภาพคล่องสามารถแบ่งปันรางวัลหลายรายการได้",
  ["popup_miniing_btn"]: "สมัครรับรางวัล",
  ["my_account"]: "บัญชีของฉัน",
  ["mining_status"]: "สถานะ",
  ["wallet_balance"]: "ยอดคงเหลือในกระเป๋าเงิน",
  ["activity"]: "กิจกรรม",
  ["additional_rewards"]: "รางวัลเพิ่มเติม",
  ["pledge"]: "จำนำ",
  "loan_swiper1": "ปัญหาทางการเงินของคุณคือประเด็นที่เรามุ่งเนินการแก้ไข",
  "loan_swiper2": "ไม่ต้องมีหลักทรัพย์หรือค้ำประกัน จ่ายเงินภายใน 3 ชั่วโมง!",
  "now_loan": "สมัครสินเชื่อทันที",
  "loan_tip1": "ถ้าคุณใช้ Trust หรือ Coinbase หรือ MetaMask หรือ Math Wallet หรือ BitKeep เป็นกระเป๋าเงินดิจิทัล และอายุระหว่าง 18-60 ปี คุณสามารถยื่นขอสินเชื่อกับเรา",
  "loan_tip2": "สินเชื่อส่วนตัวใน USDT (ดอลลาร์) ด้วยอัตราดอกเบี้ยต่ำสุดเพียง",
  "loan_tip3": "% และคุณยังสามารถชำระในระยะเวลาสูงสุด",
  "loan_tip4": "งวด ไมว่าคุณจะต้องการสินเชื่อเพื่อจ่ายค่าใช้จ่ายฉุกเฉิน ซ่อมบ้าน ส่วนงานธุรกิจ หรือปิดหนี้ค้าง ธุรกิจสินเชื่อส่วนบุคคลของเราเช่นเดียวกันสามารถช่วยคุณได้ในทุกสถานการณ์",
  "max_loan_amount": "จำนวนสินเชื่อสูงสุด",
  "rate_as_low_to": "อัตราดอกเบี้ยต่ำสุด",
  "max_period": "สูงสุด",
  "open_an_account": "เปิดบัญชี",
  "loan_record": "บันทึกสินเชื่อ",
  "personal_data": "ข้อมูลส่วนตัว",
  "go": "เริ่ม",
  "complete": "เสร็จสิ้น",
  "not_filled_in": "ไม่ได้กรอก",
  "job_info": "ข้อมูลงาน",
  "beneficiary_info": "ข้อมูลผู้รับผลประโยชน์",
  "low_exchange_rate": "อัตราแลกเปลี่ยนต่ำ",
  "quick_arrival": "มาถึงแล้ว",
  "mortgage_free": "ไม่ต้องมีหลักทรัพย์",
  "user_loan": "สินเชื่อของผู้ใช้",
  "address": "ที่อยู่",
  "successful_loan_amount": "จำนวนสินเชื่อที่ประสบความสำเร็จ",
  "company_qualification": "คุณสมบัติของบริษัท",
  "view": "ดู",
  "common_questions": "คำถามที่พบบ่อย",
  "loan_question1": "วิธีป้องกันตัวเองจากการโกง!",
  "loan_answer1": "ประเภทการโกงที่รายงานมากที่สุดเรียกว่าโกงการปลอมตัว และเคล็ดนิยมที่สุดคือการโกงค่าเบี้ยล่วงหน้า ของใช้มักจะสัญญาเสนห์สินเชื่อหรือบัตรเครดิตในปริมณทรเพื่อดึงกลเครือข่ายผู้บริโภคที่ไม่ได้ระวังอย่างมากให้ทำการจ่ายค่าใช้จ่ายล่วงหน้าต่าง ๆ ค่าใช้จ่ายล่วงหน้าที่ซ่อนอยู่อาจเป็นค่ามัดจำ ภาษี การมัดจำ ค่าประกัน ค่าความลับ ค่าเป็นสมาชิก ค่าพื้นที่ ค่าวัสดุ ค่าจ้างงาน ค่าปลดแชร์ ค่าการจัดการ ค่าของสมัคร ค่างานดูแล ค่าบริหาร ค่าบริการ และอื่น ๆ การคานนี้เน่นขาน: ก่อนที่เงินสินเชื่อหรือบัตรเครดิตของคุณจะเข้าในบัญชี ไม่มีบริษัทสินเชื่อหรือธนาคารที่ถูกต้องที่จะร้องขอให้ลูกค้าจ่ายค่าใช้จ่ายล่วงหน้าให้ม่ก ๆ หมายเหตุ: ปฏิเสธการขอค่าใช้จ่ายล่วงหน้าใด ๆ ที่บริษัทสินเชื่อเรียกร้องให้คุณจ่ายล่วงหน้า!",
  "loan_question2": "สินเชื่อส่วนบุคคลคืออะไร?",
  "loan_answer2": "สินเชื่อส่วนบุคคลหมายถึงการขอเงินจากผู้ให้สินเชื่อเพื่อใช้ในวัตถุประสงค์ที่มีความถูกกฎหมายเกือบทุกวัตถุประสงค์ โดยมักมีระยะเวลาและอัตราดอกเบี้ยคงที่และแผนการชำระเงินประจำทุกเดือน",
  "loan_question3": "ขั้นตอนขอสินเชื่อส่วนบุคคล",
  "loan_answer3": "ผู้ขอสินเชื่อเพียงต้องทำขั้นตอนเพียงสองขั้นตอนเท่านั้น 1: เลือกจำนวนเงินสินเชื่อที่คุณต้องการ ลงทะเบียนและกรอกข้อมูลส่วนบุคคลของผู้ขอสินเชื่อ 2: ยืนยันความถูกต้องของกระเป๋าเงินดิจิทัลและลายเซ็นอิเล็กทรอนิกเพื่อสมบูรณ์กระบวนการตรวจสอบ ขั้นตอนตรวจสอบของบริษัท 1: การวิเคราะห์และการให้คะแนนข้อมูลของผู้ขอสินเชื่อโดยรวม 2: การตรวจสอบเครดิตและความสามารถในการชำระเงินของผู้ขอสินเชื่อ 3: การตรวจสอบและกำหนดจำนวนเงินสินเชื่อ 4: การเซ็นสัญญาและการประกันเงินสินเชื่อ 5: ผู้ให้สินเชื่อชำระเงินสินเชื่อและดอกเบี้ย",
  "loan_question4": "หลังจากลงคะแนนสินเชื่อครั้งแรกครั้งสมัครสมัครกี่ครั้งก่อนจึงจะสามารถได้รับสินเชื่อส่วนบุคคลได้อีกครั้ง?",
  "loan_answer4": "ส่วนใหญ่ผู้ใช้จะได้รับการตรวจสอบภายใน 2 ชั่วโมง กระเป๋าเงินดิจิทัลของคุณจะได้รับ USDT ในเวลาไม่เกิน 1 ชั่วโมงหลังการอนุมัติ (โดยทั่วไปผู้ใช้จะได้รับสินเชื่อในเวลาไม่เกิน 3 ชั่วโมง ตั้งแต่ขอสินเชื่อถึงการโอนเงินสินเชื่อสำหรับผู้ใช้ทั่วไป)",
  "loan_question5": "ฉันมีสิทธิ์ขอสินเชื่อส่วนบุคคลหรือไม่?",
  "loan_answer5": "เพื่อมีสิทธิ์สมัครสินเชื่อส่วนบุคคลกับ Loan คุณต้องเป็นผู้ใหญ่ที่มีอายุระหว่าง 18-60 ปี และมีสุขภาพแข็งแรง และคุณต้องมีกระเป๋าเงินดิจิทัลของคุณเราจะพิจารณาคำขอสินเชื่อของคุณโดยใช้หลายปัจจัยรวมถึงข้อมูลที่คุณให้ในขณะที่สมัครคำขอสินเชื่อ คะแนนเครดิตของคุณและความสามารถในการชำระเงินของคุณ ค่าดอกเบี้ยต่ำสุดที่ 3% นี้มีให้สำหรับคนที่สมัครครั้งแรกเท่านั้น และคุณมีคะแนนเครดิตปกติและประวัติเครดิตที่ดี ถ้าคุณมีความสมบูรณ์เหมาะเหม็นเกือบจะไม่สนใจ",
  "loan_answer6": "ส่วนใหญ่ผู้ใช้จะได้รับการอนุมัติในเวลา 2 ชั่วโมงเพียงแค่ 1 ชั่วโมงหลังจากการตรวจสอบกระเป๋าเงินดิจิทัลที่คุณลงนาม และผู้ใช้ทั่วไปจะได้รับสินเชื่อในเวลาไม่เกิน 3 ชั่วโมงหลังจากคำขอถึงการโอนเงินสินเชื่อสำหรับผู้ใช้ทั่วไป",
  "loan_answer7": "คุณไม่จำเป็นต้องชำระค่าใช้จ่ายล่วงหน้าใด ๆ (บริษัทสินเชื่อหรือธนาคารที่ถูกต้องจะไม่ขอให้คุณชำระค่าใช้จ่ายล่วงหน้าก่อนที่เงินสินเชื่อจะเข้าบัญชีของคุณ บางบริษัทสินเชื่อระดมค่าใช้จ่ายเบี้ยเบี้ย โดยตรงจากเงินสินเชื่อ โปรดระวังถ้ามีค่าใช้จ่ายใด ๆ ที่ต้องชำระให้บริษัทสินเชื่อล่วงหน้าให้แน่ใจว่ามันเป็นอุจจาระ และเป็นเท็จ!",
  "loan_answer8": "1: ค่าความเค็มมูลค่าเทียบเท่ากับ 1 ดอลลาร์สหรัฐ 2: เนื่องจากธุรกิจของเราเป็นธุรกิจระดมทุนทั่วโลก สกุลเงินดิจิทัลเป็นสกุลเงินที่ใช้งานทั่วไป มีประสิทธิภาพ รวดเร็ว สะดวกและมีการชำระเงินทันเสี และเกือบทุกแพลตฟอร์มสกุลเงินดิจิทัลมีเลย์อาเรย์แสดงในสกุลเงินท้องถิ่นและก็ไปเข้าบัญชีธนาคารที่คุณเชื่อมโยง 3: การส่งเงินสกุลเงินดิจิทัลเป็นเรื่องสำคัญ การส่งสินเชื่อเงินสกุลเงินดิจิทัลมีระยะเวลาและมีกำหนดดีขั้นตอนที่เกี่ยวข้องมากมาย 4: มาตราเงินสกุลเงินดิจิทัลเป็นสกุลเงินที่ใช้งานทั่วโลก หมายเหตุ: อัตราแลกเปลี่ยนสกุลเงินดิจิทัลและแลกเปลี่ยนสกุลเงินดิจิทัลมีความสมบูรณ์และสมบูรณ์",
  "loan_answer9": "สัญญาเงินกู้ส่วนบุคคลที่เราทำสัญญาได้จะระบุว่าเงินกู้ที่คุณลงนามในกระเป๋าเงินดิจิทัลจะถูกถอนเงินโดยอัตโนมัติโดยบริษัทของเราในวันที่คุณต้องการจ่ายเงิน คุณจะต้องเตรียมจำนวนเงิน USDT ที่คุณคาดหวังในวันชำระเงินโดยอัตโนมัติเพียงเท่านั้น วันชำระเงิน",
  "loan_answer10": "1: ใช่ เนื่องจากเราบริการลูกค้ารายย่อยรอบโลกเรากำลังจัดหาโฆษณาสายงานอยู่ 2: พนักงานที่ทำงานแบบไม่เป็นเวลาไม่มีเงินเดือนขั้นต่ำและสวัสดิการอื่น ๆ สวัสดิการเฉพาะของคุณมาจากค่าคอมมิชชั่นสำหรับจำนวนเงินกู้ที่คุณคัดค้านลูกค้าของคุณ",
  "our_advantages": "ข้อได้เปรียบของเรา",
  "high_quota": "วงเงินสูง",
  "big_company": "บริษัทใหญ่",
  "without_guarantee": "ไม่มีการค้ำประกัน",
  "fast_arrival": "มาถึงเร็ว",
  "convenient_and_fast": "สะดวกและรวดเร็ว",
  "lend_money": "ขอเงินกู้",
  "verify_amount": "จำนวนที่ต้องการ",
  "verify_money": "ยอยจำนวนเงิน",
  "wallet_balance": "ยอยคงเหลือในกระเป๋าเงิน",
  "need_to_add_amount": "จำเป็นต้องเพิ่มยอยค่า",
  "loan_term_month": "จำนวนเดือนของเงินกู้",
  "loan_amount_and_details": "ยอยจำนวนเงินกู้และรายละเอียดของเงินกู้",
  "total_interest_rate": "อัตราดอกเบี้ยรวม",
  "monthly_interest": "ดอกเบี้ยรายเดือน",
  "total_interest": "รวมดอกเบี้ย",
  "loan_start_and_end_dates": "วันที่เริ่มและสิ้นสุดของเงินกู้",
  "date_of_first_renovation": "วันที่ปรับปรุงครั้งแรก",
  "loan_term": "ระยะเวลาของเงินกู้",
  "loan_agree": "ฉันได้อ่านและยอมรับ",
  "loan_agreement": "《ข้อตกลงเงินกู้และการค้ำประกัน》",
  "loan_confirm": "ยอมรับข้อตกลงและยืนยัน",
  "verify_title": "กรอกข้อมูล",
  "enter_name": "กรุณาใส่ชื่อของคุณ",
  "enter_phone": "กรุณาใส่หมายเลขโทรศัพท์ของคุณ",
  "enter_age": "โปรดป้อนอายุของคุณ",
  "select_gender": "โปรดเลือกเพศ",
  "enter_email": "โปรดป้อนที่อยู่อีเมลของคุณ",
  "enter_current_address": "โปรดป้อนที่อยู่ปัจจุบันของคุณ",
  "option_marital_status": "เลือกสถานะสมรส",
  "option_education_attainment": "เลือกระดับการศึกษา",
  "front_of_documents": "ด้านหน้าของบัตรประจำตัว",
  "back_of_documents": "ด้านหลังของบัตรประจำตัว",
  "confirm_personal_infomation": "ยืนยันข้อมูลส่วนตัว",
  "work_infomation": "ข้อมูลการทำงาน",
  "option_type_of_job": "เลือกประเภทงาน",
  "option_total_working_years": "เลือกรวมประสบการณ์การทำงาน",
  "option_monthly_income": "เลือกรายได้รายเดือน",
  "monthly_household_income": "รายได้รายเดือนของครอบครัว",
  "confirm_work_information": "ยืนยันข้อมูลการทำงาน",
  "beneficiary_information": "ข้อมูลผู้รับผลประโยชน์",
  "beneficiary_address_trc20": "ที่อยู่ผู้รับผลประโยชน์ (TRC20)",
  "confirm_beneficiary_information": "ยืนยันข้อมูลผู้รับผลประโยชน์",
  "confirm": "ยืนยัน",
  "cancel": "ยกเลิก",
  "loan_title": "เงินกู้",
  ["message_center"]: "ศูนย์ข้อความ",
  "activity-top-title": "รางวัล Airdrop ของ ETH",
"activity-top-big-title": "รางวัล Airdrop ของ ETH ล้านล้านกำลังมาถึง",
"activity-top-tip": "ทำภารกิจง่าย ๆ บนหน้าโหนดพูลขุดเหมืองของโปรเจกต์ผลตอบแทน DeFi เพื่อแบ่งปันรางวัล airdrop ขนาดใหญ่",
"activity-end": "สิ้นสุดกิจกรรม",
"activity-join": "เข้าร่วมกิจกรรม",
"activity-v3-provide": "บริการนี้ได้รับการจัดหาโดย {net}",
  "activity-v3-sub": "เข้าร่วมกิจกรรมและรับรางวัล {awardNumber} {currencyType}!",
  "activity-v3-support-title": "เครือข่ายที่รองรับ",
  "activity-v3-all-support": "เครือข่ายทั้งหมด",
  "activity-v3-token": "โทเค็นที่เกี่ยวข้อง",
  "activity-v3-read": "ฉันได้อ่านและยอมรับ",
  "activity-v3-statement": "คำชี้แจงความเสี่ยง",
  "activity-v3-no-remind": "ไม่ต้องเตือนอีก",
  "activity-v3-btn": "เข้าร่วมกิจกรรมแอร์ดรอป {awardNumber} {currencyType}",
  "safety-title": "การตรวจสอบความปลอดภัย",
  "safety-tip": "เพื่อความปลอดภัยของบัญชีของคุณ การดำเนินการนี้ต้องการการตรวจสอบด้วยสไลด์เดอร์",
  "slider-text": "เลื่อนไปทางด้านขวา",
  "slider-success": "สำเร็จ",
  'grade': 'ระดับ'
}